import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../shared/services/authentication.service';
import { environment, TOKEN_DASHBOARD } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(public appService: AuthenticationService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.appService.getCurrentJwt();
    const tokenDash = TOKEN_DASHBOARD;
    const isApiBaseRequest = request.url.startsWith(environment.API_BASE_URL);
    const isCepRequest = request.url.includes('viacep.com')
      || request.url.includes('brasilapi.com.br')
      || request.url.includes('opencep.com');

    if (isApiBaseRequest) {
      request = request.clone({
        setHeaders: {
          'x-application-id': environment.APPLICATION_ID
        }
      });
    }

    if (token != null && token.length > 0 && !isCepRequest && !request.url.includes('dashboard-api.ozcambio.com.br')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    if (tokenDash != null && tokenDash.length > 0 && request.url.includes('dashboard-api.ozcambio.com.br')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenDash}`
        }
      });
    }
    return next.handle(request);
  }
}
